import React,{useEffect,useState} from 'react';
import {
  SinglePageHeader,
  FooterWithoutAuth,
  Button,
  Layout,
} from 'components';
import { Swiper, SwiperSlide } from 'swiper/react';
import './packages-and-payment-page.less';

import './main-page';
import papAccessory1 from '../../assests/images/pap-accessory-1.png';
import papAccessory2 from '../../assests/images/pap-accessory-2.png';
import papAccessory3 from '../../assests/images/banner-accessory-1.png';
import PackageBoxes from '../packages/partials/boxes';
import bannerAccessory2 from '../../assests/images/banner-accessory-2.png';
import { LANDING_MENU } from 'constants/page.const';
import { getDefaultPackageList } from 'services/omcc.service';
import { MetaTags } from 'react-meta-tags';
import { PackageProvider } from 'context/package.context';
const PackagesAndPayment = () => {
  const mockList = [
    { id: 0, no: 0, name: 'Mini', credit: 1500, prize: 320 },
    { id: 1, no: 1, name: 'Mini+', credit: 3500, prize: 600 },
    { id: 2, no: 2, name: 'Mini++', credit: 7500, prize: 1300 },
    { id: 3, no: 3, name: 'Midi', credit: 15000, prize: 2600 },
    { id: 4, no: 4, name: 'Midi+', credit: 25000, prize: 3900 },
    { id: 6, no: 5, name: 'Midi++', credit: 50000, prize: 7600 },
    { id: 6, no: 6, name: 'Maxi', credit: 100000, prize: 13000 },
    { id: 7, no: 7, name: 'Maxi+', credit: 250000, prize: 30000 },
  ];
  const [packageList, setPackageList] = useState(mockList);

  useEffect(() => {
    //getPackages();
  }, []);

  const getPackages = () => {
    getDefaultPackageList().then((result) => {
      setPackageList(result.packageList);
    });
  };
  return (
    <Layout
      hamburgerMenuWithButton={true}
      hamburgerMenuData={LANDING_MENU}
      hamburgerMenuClass="single-page-v1"
      withoutHeaderDropdown={true}
      withoutCreditInfo={true}
      menuSinglePageV2={true}
      customMenuRender={() => <SinglePageHeader />}
    >
      {' '}
      <PackageProvider>
        <MetaTags>
          <title>
          Toplu SMS Paketleri ve Fiyatları - Mesaj Üssü
          </title>
          <meta
            name="description"
            content="Turkcell Mesaj Üssü aboneliğinizi başlattıktan sonra toplu SMS paketleri ve fiyatlarını inceleyebilir, size uygun toplu sms paketini seçebilirsiniz."
          />
          <link rel="canonical" href="https://mesajussu.turkcell.com.tr/paketler" />
        </MetaTags>
        <div className="packages-and-payment-page">
          <div className="packages-wrapper">
            <div className="container">
              <PackageBoxes
                title="Mesaj Üssü'ne üye olun, sizin için uygun olan mesaj paketini satın alın, hemen müşterilerinize mesaj göndermeye başlayın."
                list={packageList}
                selectable={false}
              />
              <img
                id="pap-accessory-1"
                src={papAccessory1}
                alt="Toplu SMS Paketleri ve Fiyatları - Mesaj Üssü 1"
              />
              <img
                id="pap-accessory-2"
                src={papAccessory2}
                alt="Toplu SMS Paketleri ve Fiyatları - Mesaj Üssü 2"
              />
              <img
                id="pap-accessory-3"
                src={papAccessory3}
                alt="Toplu SMS Paketleri ve Fiyatları - Mesaj Üssü 3"
              />
            </div>
            
          </div>
          <div className="blog-page blog-page--marketing">
        <div className="blogs-wrapper">
          <div className="container">
        MesajÜssü'nde farklı ihtiyaçlara yönelik olarak toplamda 8 farklı toplu sms paketi sunulmaktadır. Geniş bir toplu SMS ücret aralığına sahip bu seçeneklerde kısa, orta ve uzun vadeli olarak kullanabileceğiniz toplu mesaj paketleri yer almaktadır. İhtiyacınıza ve planlamalarınıza göre seçebileceğiniz başlıklı SMS paketlerinde birim fiyatlar değişiklik göstermektedir. En küçük kurumsal mesaj paketinin birim bazlı fiyatı 0.2133 TL tutarındadır. Satın alabileceğiniz kurumsal mesaj paketleri büyüdükçe birim bazında maliyetiniz azalmaktadır. Nitekim Maxi+ toplu mesaj paketinin birim fiyatı, Mini pakete kıyasla daha uygundur.
<br/>
Toplu SMS satın almak istemeniz durumunda hemen kısa ve uzun vadeli planlamalarınızı göz önünde bulundurarak toplu mesaj ücretlerini incelemeye başlayabilirsiniz. Size uygun seçeneklerden bir tanesini seçerek hızlı ve kolay bir şekilde avantajlı toplu SMS fiyatlarından yararlanmaya başlayabilirsiniz. Üyeliğinizi başlattığınız gün itibarıyla kurumsal SMS paketinizi kullanmaya başlayabilir, raporlar aracılığıyla analizler yaparak en doğru hedef kitlenize ulaşabilirsiniz. Toplu SMS fiyatlarına ve paketlerine dair herhangi bir sorunuz olması halinde 0 532 532 0000 numaralı hat üzerinden yetkililer ile iletişime geçebilirsiniz.
        </div></div></div>
        </div>
       
      </PackageProvider>
      <FooterWithoutAuth />
    </Layout>
  );
};

export default PackagesAndPayment;
